// extracted by mini-css-extract-plugin
export default {"wrapper":"StationAdresses_wrapper__lSblf","title":"StationAdresses_title__idaFQ","dataForm":"StationAdresses_dataForm__4bMK1"};